import React from "react";
import PropTypes from "prop-types";

const getSaveBarMessage = (dirty, validation, validationAttempted) => {
  if (validationAttempted) {
    return "";
  }

  if (validation.unmarkedCount > 0) {
    return `Pozostało ${validation.unmarkedCount} niezaznaczonych`;
  }

  return dirty ? "Niezapisane zmiany" : "Gotowe do zapisu";
};

function AttendanceSaveBar({
  canEdit,
  dirty,
  validation,
  validationAttempted,
  saving,
  onSave,
  onReturn,
}) {
  const message = getSaveBarMessage(dirty, validation, validationAttempted);

  return (
    <div className="attendance-page__save-bar">
      <div className="attendance-page__save-actions">
        <button type="button" className="btn manage-button manage-red-button" disabled={saving || !canEdit} onClick={onSave}>
          {saving ? "Zapisywanie..." : "Zapisz obecność"}
        </button>
        <button type="button" className="btn manage-button manage-teal-button" disabled={saving} onClick={onReturn}>
          Powrót
        </button>
      </div>
      {message && (
        <div className="attendance-page__save-message">
          {message}
        </div>
      )}
    </div>
  );
}

AttendanceSaveBar.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  validationAttempted: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onReturn: PropTypes.func.isRequired,
};

export default AttendanceSaveBar;
